import { useEffect, useState, React } from "react";

import axios from "axios";
import { useAuthContext } from "../Hooks/useAuthContext";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap"
import { NavLink, useNavigate, Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

// Libraries
import { Form, InputGroup } from "react-bootstrap";
import moment from "moment/moment";

export default function OrderTable(params) {
    const navigate = useNavigate()
    const { user } = useAuthContext();

    const [orders, setOrders] = useState([]);

    

    useEffect(() => {


 

        // Load orders
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/MyOrders`, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                if (res.status === 200) {
                    setOrders(res.data);
                }
            })
    }, [])

    const styles = {
        order: {
            /*boxShadow: "0.05rem 0.05rem 1rem rgba(0, 0, 0, 0.3)",*/
            
	        borderRadius: "0.25rem",
            overflow: "hidden",
            marginBottom: 10,
            paddingTop: 5,
            paddingBottom: 5,
            cursor: "pointer"
        },

        statusInProgress: {
            borderTop: "1em solid #A6A6A6",
            borderLeft: "1px solid #A6A6A6",
            borderRight: "1px solid #A6A6A6",
            borderBottom: "1px solid #A6A6A6",
        },

        statusPendingApproval: {
            borderTop: "1em solid #FD64C3",
            borderLeft: "1px solid #A6A6A6",
            borderRight: "1px solid #A6A6A6",
            borderBottom: "1px solid #A6A6A6",
        },

       

        statusText: {
            color:"#999"
        }

        
    }
    

    return (
        <div style={{ marginBottom: 40 }}>
            <h3>My Orders <button className="btn-sm btn-primary" onClick={() => { navigate(`/Orders/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button></h3>

            {orders && (orders.map((order) => {

                var style = styles.statusInProgress;

                switch (order.status) {
                    case "In Progress":
                        style = styles.statusInProgress;
                        break;
                    case "Pending Approval":
                        style = styles.statusPendingApproval;
                        break;
                    
                }



                return (
                    <div className="row" style={{ ...styles.order, ...style }} key={order.id} onClick={() => navigate(`/Orders/View/${order.id}`) }>

                        <div className="col-8">
                            <h5>{order.id} - {order.customer.name}</h5> 
                        </div>
                        <div className="col-4" style={{...styles.statusText, textAlign: "right"}}>
                            {order.status}
                        </div>

                        <div className="col-8">
                            Agent: {order.agent.name}
                        </div>
                        <div className="col-4" style={{textAlign:"right"}}>
                        {moment(order.dateOrdered).format('DD/MM/YYYY')}<br/>
                        </div>
                    </div>
                )
            }))}

            {orders == "" && (<em>You dont have any orders in progress</em>)}

               
        </div>
    )
}
